import React, { useEffect, useState } from 'react'
import { Box, Link } from 'rebass/styled-components'
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox'
import AnimationWrapper from '../helpers/Animations'
import MediaRender from '../components/general/MediaRender'
import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'
import Spacer from '../components/general/Spacer'

const Headline = styled(Box)`
    color: ${(props) => props.theme.colors.black};
    font-family: ${(props) => props.theme.fonts.heading};
    font-weight: ${(props) => props.theme.fontWeights.semibold};
    font-size: ${(props) => props.theme.fontSizes.h3};
    letter-spacing: 4px;
    line-height: 34px;
    text-transform: uppercase;
    text-decoration: none !important;

    @media (max-width: ${(props) => props.theme.breakpoints.md}) {
        font-size: ${(props) => props.theme.fontSizes.h4};
        letter-spacing: auto;
        line-height: 26px;
    }
`

const GalleryGrid = ({ options }) => {
    const [data, setData] = useState([])
    const srlOptions = {
        buttons: {
            showDownloadButton: false,
        },
    }
    useEffect(() => {
        if (
            options.media &&
            options.media.set &&
            options.media &&
            options.media.set.length
        ) {
            const items = []
            Object.entries(options.media.set).map(([key, image]) => {
                items.push(
                    <Link
                        key={key + '-' + image.public_id}
                        href={`https://res.cloudinary.com/kidston/image/upload/${image.filepath}${image.filename}`}
                        sx={{
                            textDecoration: 'none',
                        }}
                    >
                        <AnimationWrapper type='fade-up'>
                            <MediaRender
                                file={image}
                                options={{
                                    backgroundVideo: false,
                                    backgroundImage: false,
                                }}
                                alt={image.caption}
                            />
                            <Headline pt='xs'>{image.caption}</Headline>
                        </AnimationWrapper>
                    </Link>
                )
            })
            setData(items)
        }
    }, [options])
    return (
        <Spacer spacing={options.spacing}>
            {data.length ? (
                <SimpleReactLightbox>
                    <SRLWrapper options={srlOptions}>
                        <Box
                            variant='container'
                            py='md'
                            sx={{
                                display: 'grid',
                                gridGap: 'md',
                                gridTemplateColumns: [
                                    '1fr',
                                    '1fr',
                                    '1fr',
                                    'repeat(2, 1fr)',
                                    'repeat(3, 1fr)',
                                ],
                            }}
                        >
                            {data}
                        </Box>
                    </SRLWrapper>
                </SimpleReactLightbox>
            ) : (
                <Skeleton height={787} />
            )}
        </Spacer>
    )
}

export default GalleryGrid
